export default __webpack_public_path__ + "static/media/01.3410dfe7.png";